import { render, staticRenderFns } from "./SideList.vue?vue&type=template&id=5147adf2&scoped=true&"
import script from "./SideList.vue?vue&type=script&lang=js&"
export * from "./SideList.vue?vue&type=script&lang=js&"
import style0 from "./SideList.vue?vue&type=style&index=0&id=5147adf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5147adf2",
  null
  
)

export default component.exports